import React from 'react';
import { Section } from './ui/Section';
import { TestimonialCard } from './ui/TestimonialCard';
export function InitialTestimonials() {
  const testimonials = [{
    quote: 'Organicé todo el año en una tarde. Ahora tengo cada clase pensada y secuenciada para todos mis grupos. Nunca más el domingo de pánico preparando qué dar el lunes.',
    name: 'Rodrigo M.',
    location: 'Buenos Aires',
    role: 'Profe de Funcional en Gimnasio Propio'
  }, {
    quote: 'Los WODs con progresión real por nivel cambiaron todo. Mis alumnos mejoraron más en 2 meses que en todo el año anterior. Y dejaron de irse.',
    name: 'Martín G.',
    location: 'Rosario',
    role: 'Profe en Box de CrossFit y Clases Grupales'
  }, {
    quote: 'Adapto el mismo WOD a 3 niveles distintos en 5 minutos. Antes me llevaba horas pensar qué hacer con un grupo heterogéneo.',
    name: 'Luciana F.',
    location: 'Córdoba',
    role: 'Profe de Funcional Grupal e Individual'
  }];
  return <Section bg="dark-900" className="border-b border-dark-800" data-id="element-257">
      <div className="text-center mb-8 md:mb-16" data-id="element-258">
        <h2 className="text-2xl md:text-4xl font-display font-bold text-white mb-3 md:mb-4" data-id="element-259">
          LO QUE DICEN LOS PROFES
        </h2>
        <div className="w-16 md:w-24 h-1 bg-lime-500 mx-auto rounded-full" data-id="element-260"></div>
      </div>

      <div className="grid md:grid-cols-3 gap-4 md:gap-8" data-id="element-261">
        {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-262" />)}
      </div>
    </Section>;
}